.selectRoot {
  position: relative;
  color: var(--mantine-color-gray-8);
  min-height: 42px;
}

.selectLabel {
  position: absolute;
  pointer-events: none;
  font-size: var(--mantine-font-size-xs);
  margin-left: var(--mantine-spacing-sm);
  padding-left: calc(var(--mantine-spacing-xs) / 2);
  padding-right: calc(var(--mantine-spacing-xs) / 2);
  background-color: white;
  top: -10px;
  z-index: 2;
}

.selectInput {
  font-family: "Work Sans";
  padding-top: 7px;
  padding-bottom: 5px;
  min-height: 42px;
}

.selectDropdown {
  background-color: var(--mantine-color-gray-0);
  border-style: solid;
  border-color: var(--mantine-color-gray-9);
}

.selectRequired {
  color: #f30505;
}
.selectOption {
  border: 1px solid transparent;
  transition: background-color 140ms ease, color 140ms ease,
    border-color 140ms ease;
}

.selectOption:hover,
.selectOption:focus {
  background-color: white;
  color: var(--mantine-color-gray-8);
  border: 1px solid var(--mantine-color-gray-4);
}

.selectRoot:has(.selectInput:disabled),
.selectRoot:has(.selectInput[data-disabled]) {
  opacity: 0.5;
  color: var(--mantine-color-gray-4);
  & .selectInput {
    cursor: not-allowed;
    background-color: inherit;
    opacity: 1;
    pointer-events: none;
    color: var(--mantine-color-gray-7);
  }
}
